"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.jdUpdateContextDescription = void 0;
function jdUpdateContextDescription(context) {
    switch (context) {
        case 'slack':
            return 'Slack messages';
        case 'fathom':
            return 'Meeting transcript';
        case 'recruiter-note':
            return 'Recruiter notes';
        case 'client-email':
            return 'Client email';
        case 'jd-review':
            return 'JD review';
        default:
            throw new Error('Invalid context for generating client updates');
    }
}
exports.jdUpdateContextDescription = jdUpdateContextDescription;
//# sourceMappingURL=jd-llm-updates.js.map